;
define("store_locator_search.tpl", function(){});

